module.exports = __webpack_public_path__ + "static/media/social2.61c28d47.png";